import api from '../plugins/api';

function getEndpoint(id, isSupport = false, isPublic = false) {
  return `${isPublic ? 'public/' : ''}conversations/${
    isSupport ? 'support/' : ''
  }${id}/logs`;
}

export default {
  namespaced: true,
  state: {
    logs: {
      // 'conversation.id': []
    },
    logsMeta: {
      // 'conversation.id': {},
    },
    logsLoading: {
      // 'conversation.id': Boolean,
    },
  },
  getters: {
    logs(state) {
      return ({ id }) => {
        return state.logs[id] || [];
      };
    },
    hasLogsMeta(state) {
      return ({ id }) => {
        return !!state.logsMeta[id];
      };
    },
    canGetMoreLogs(state) {
      return ({ id }) => {
        return !!(
          state.logsMeta[id] &&
          state.logsMeta[id].last_page > state.logsMeta[id].current_page
        );
      };
    },
    isLoading(state) {
      return ({ id }) => {
        return !!state.logsLoading[id];
      };
    },
  },
  mutations: {
    mergeLogs(state, { id, logs = [], action = 'prepend' }) {
      const existingLogs = state.logs[id] || [];
      const existingLogIds = existingLogs.map((log) => log.id);
      const newLogs = logs.filter((log) => !existingLogIds.includes(log.id));

      if (!newLogs.length) return;

      const mergedLogs =
        action === 'prepend'
          ? [...newLogs, ...existingLogs]
          : [...existingLogs, ...newLogs];

      state.logs = { ...state.logs, [id]: [...mergedLogs] };
    },
    logsMeta(state, { id, meta }) {
      state.logsMeta = { ...state.logsMeta, [id]: meta };
    },
    logsLoading(state, { id, isLoading }) {
      state.logsLoading = { ...state.logsLoading, [id]: isLoading };
    },
    markAllLogsRead(state, { id }) {
      if (!Array.isArray(state.logs[id])) return;

      state.logs[id].forEach((log) => {
        // eslint-disable-next-line no-param-reassign
        log.read = true;
        return log;
      });
    },
  },
  actions: {
    async getLogs(
      { commit, state },
      { id, isSupport = false, isPublic = false }
    ) {
      if (!id) return;

      commit('logsLoading', { id, isLoading: true });

      try {
        const response = await api.get(getEndpoint(id, isSupport, isPublic), {
          params: {
            page: state.logsMeta[id] ? state.logsMeta[id].current_page + 1 : 1,
          },
        });

        // TODO: Asked the backend why the sorting differs public vs. non-public endpoint (check line w. `reverse`)
        // @SEE https://office-guru.slack.com/archives/G01AMEJMVD5/p1648651073327059
        commit('mergeLogs', {
          id,
          logs: response.data.data.reverse(),
        });
        commit('logsMeta', { id, meta: response.data.meta });
      } finally {
        commit('logsLoading', { id, isLoading: false });
      }
    },
    async addLog(
      { commit },
      { id, payload, isSupport = false, isPublic = false }
    ) {
      const response = await api.post(getEndpoint(id, isSupport, isPublic), {
        message: payload.text,
        files: payload.files,
      });

      const log = response.data.data;
      commit('mergeLogs', { id, logs: [log], action: 'append' });
    },
  },
};
